import PropTypes from 'prop-types';
import styled from 'styled-components';
import sharedStyles from '../styles';

const ContentContainer = styled.div`
  flex: 1;
  padding: ${sharedStyles.spacing['spacing-lg']}
    ${sharedStyles.spacing['spacing-lg']};
  padding-bottom: 0;
  width: ${({ widthPercent }) => widthPercent}%;
`;

ContentContainer.propTypes = {
  widthPercent: PropTypes.number,
};

ContentContainer.defaultProps = {
  widthPercent: 100,
};

export default ContentContainer;
